// extracted by mini-css-extract-plugin
export default {"headerContent":"Group_headerContent__oWXES","layoutForm":"Group_layoutForm__ykjgE","inputForm":"Group_inputForm__8W5ry"};